import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timesContainer", "dayInput", "dayLabel"]

  connect() {
    this.syncDays()
  }

  addTime() {
    const container = this.timesContainerTarget
    const div = document.createElement("div")
    div.className = "flex items-center space-x-2"
    div.innerHTML = `
      <input type="text" name="workflow[workflow_schedule_attributes][times][]"
             value="08:00" class="input w-28" placeholder="08:00" pattern="\\d{2}:\\d{2}">
      <button type="button" data-action="schedule#removeTime"
              class="text-red-500 hover:text-red-700 text-sm">Remove</button>
    `
    container.appendChild(div)
  }

  removeTime(event) {
    const row = event.target.closest("div")
    if (this.timesContainerTarget.children.length > 1) {
      row.remove()
    }
  }

  toggleDay(event) {
    event.preventDefault()

    const index = event.currentTarget.dataset.dayIndex
    const input = this.dayInputTargets.find((target) => target.dataset.dayIndex === index)
    if (!input) return

    input.checked = !input.checked
    this.paintDay(index)
  }

  syncDay(event) {
    this.paintDay(event.currentTarget.dataset.dayIndex)
  }

  syncDays() {
    this.dayInputTargets.forEach((input) => this.paintDay(input.dataset.dayIndex))
  }

  paintDay(index) {
    const input = this.dayInputTargets.find((target) => target.dataset.dayIndex === index)
    const label = this.dayLabelTargets.find((target) => target.dataset.dayIndex === index)
    if (!input || !label) return

    if (input.checked) {
      label.style.background = "var(--accent-glow)"
      label.style.borderColor = "var(--accent)"
      label.style.color = "var(--accent)"
      label.setAttribute("aria-pressed", "true")
    } else {
      label.style.background = "var(--surface)"
      label.style.borderColor = "var(--border)"
      label.style.color = "var(--text-muted)"
      label.setAttribute("aria-pressed", "false")
    }
  }
}
